let language = {
    "RESET_PWD_URL_PARAMS_MISSING_TITLE": "",
    "RESET_PWD_URL_PARAMS_MISSING_CONTENT": "Url params is missing",
    
    "RESET_PWD_FAILED_TITLE": "Reset password fail",
    "RESET_PWD_FAILED_CONTENT": "The password is different from the confirm password.",
    
    "RESET_PWD_SUCCESS_TITLE": "Reset password successfully!",
    "RESET_PWD_SUCCESS_CONTENT": "Your password has been successfully changed. You can click [OK] to proceed to the login page or click [CANCEL] to stay on the current page."
};

export { language }